module.exports = __webpack_public_path__ + "static/media/7.8f0543e9.svg";